import { AccordionActions, makeStyles, AccordionSummary, TextField } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles'
import { theme } from '../../styles/setTheme'

import '../../styles/fonts.css' //Anadido ricardo
// import Typography from 'typography'

// const typography = new Typography({
// //   baseFontSize: '38px',
// //   baseLineHeight: 1.45,
//   headerFontFamily: ['Avenir Next', 'Helvetica Neue', 'Segoe UI', 'Helvetica', 'Arial', 'sans-serif'],
//   bodyFontFamily: ['Georgia', 'serif'],
//   // See below for the full list of options.
// })

export const useStyles = makeStyles((theme) => ({
    form: {
        width: '100%',
        marginBottom: 0,
        // fontFamily: "HelveticaBold",
    },
    icon: {
        color: "#ffffff",
    },
    iconExpander: {
        color: "#000",
    },
    detalle: {
        padding: "25px 10px 20px",
    },
    wrapper: {
        position: 'relative',
    },
    captchaProgress: {
        color: theme.palette.secondary.main,
        position: 'absolute',
        top: '50%',
        left: '30%',
    },
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: theme.spacing(1),
    },
    textDisabled: {
        color: theme.palette.primary.main,
        fontWeight: 'bold',
    },
    /*wrapper: {
        position: 'relative',
    },*/
    fieldProgress: {
        color: theme.palette.secondary.primary,
        position: 'absolute',
        top: '50%',
        left: '80%',
        marginTop: -6,
        marginLeft: -12,
    },
    autocompleteProgress: {
        color: theme.palette.secondary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -6,
        marginLeft: -12,
    },
    /*form: {
        width: '100%',
        marginBottom: 0,
        marginTop: '12px',
    },*/
    
    //Agregado
    // heading: {
    //     // fontFamily: 'HelveticaBold',
    //     fontFamily: typography.toString(),
    // }, 

    inputStyle: {
        "& .MuiOutlinedInput-adornedEnd" :{
            paddingRight: '0px'
        },
        "& .MuiInputBase-input" :{
            // fontFamily: 'HelveticaBold',
        },
        /*"& .MuiInputBase-input:focus" :{
            borderBottom: '2px solid #4285f4 !important',
        },*/
        "& .MuiInput-underline:after" :{
            borderBottom: '2px solid #4285f4 !important',
        },
        '& label': {
            // fontFamily: 'HelveticaBold',
        },
        //Color del label con el foco
        '& label.Mui-focused': {
          color: '#4285f4',
        },
        '& error': {
            // fontFamily: 'HelveticaBold',
        },
        "& .MuiFormHelperText-root.Mui-error":{
            // fontFamily: 'HelveticaBold',
        },


        /*"& .MuiInput-underline:after":{
            BorderBottom: '2px solid #4285f4',
        }*/
        //borderBottom: '1px solid #4285f4 !important',
    },

    selectStyle: {
        // fontFamily: 'HelveticaBold',
        "& .MuiInputBase-input" :{
            // fontFamily: 'HelveticaBold',
        },
        "& .MuiInput-underline:after" :{
            borderBottom: '2px solid #4285f4 !important',
        },
        //Color del label con el foco
        '& label.Mui-focused': {
          color: '#4285f4',
        },
    },

    buttonStyle : {
        "& button": {
            color: '#fff',
            backgroundColor: '#0000ff',
        },
        /*
        "& .MuiButton-root" : {
            fontFamily: 'HelveticaBold',
        },*/
        //backgroundColor: '#4285f4',
        // fontFamily: 'HelveticaBold',
        ':hover': {
            backgroundColor: '#4285f4',
        },

        "& .MuiButton-root.MuiButton-containedPrimary" : {
            backgroundColor: '#4285f4',
        },
        
        "& .MuiButton-containedPrimary:hover" : {
            backgroundColor: '#4285f4',
        }
    }
    
}));

export const StyledAccordionSummary = withStyles({
    root: {
       // backgroundColor: theme.palette.primary.main,
        backgroundColor: "#ddd",
        borderBottom: "1px solid #A8A8A8",
        //color: "#ffffff",
        marginBottom: -1,
        minHeight: 30,
        fontSize: 15,
        fontWeight: 500,
        color: "#000000",
        // fontFamily: "HelveticaBold",


       // boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
        '&$expanded': {
            minHeight: 30,
        },
    },
    content: {
        '&$expanded': {
            margin: '0px 0',
        },
    },
    expanded: {},
})(AccordionSummary);

export const StyledAccordionActions = withStyles({
    root: {
        padding: '8px 25px',
    },
})(AccordionActions);


export const StyledTextField = withStyles({
    root: {
        "& .MuiInputBase-root.Mui-disabled": {
            color: "rgba(0, 0, 0, 0.87)" // (default alpha is 0.38)
            // color: "rgba(0, 0, 0, 0.6)" // (default alpha is 0.38)
        },
        "& .MuiInputBase-input" :{
            // fontFamily: 'HelveticaBold',
        },
        
        '& label': {
            // fontFamily: 'HelveticaBold',
        },
        "& .MuiFormHelperText-root":{
            // fontFamily: 'HelveticaBold',
        },
        "& .MuiFormHelperText-root.Mui-error":{
            // fontFamily: 'HelveticaBold',
        },
    }
})(TextField);